import { render, staticRenderFns } from "./IconEditionModalFaTab.vue?vue&type=template&id=05323d26&scoped=true&"
import script from "./IconEditionModalFaTab.vue?vue&type=script&lang=js&"
export * from "./IconEditionModalFaTab.vue?vue&type=script&lang=js&"
import style0 from "./IconEditionModalFaTab.vue?vue&type=style&index=0&id=05323d26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05323d26",
  null
  
)

export default component.exports